module.exports = __webpack_public_path__ + "static/media/YF89_1.768a448e.jpg";